<template>
  <div class="comment-pop flexCenter" v-if="visible">
    <div class="comment-pop-content">
      <div class="close-btn">
        <img src="@/assets/alert_close.png" @click.stop="visible = false" />
      </div>
      <div class="main-container">
        <div class="main-left-container">
          <canvas ref="canvas" :width="canvasWidth" :height="canvasHeight" class="drawing-canvas"
            :style="backgroundStyle"></canvas>

          <!-- 工具栏 -->
          <div class="toolbar">
            <div @click="setCanvasType('eraser')" class="eraser-container">
              <div class="eraser-container-item">
                <img class="eraser-icon" src="../assets/icon-eraser.png" />
                <img v-if="actionType == 'eraser'" src="../assets/icon_selected.png"
                  style="width:1.8rem;height:1.8rem;position:absolute;bottom:0;right:0" />
              </div>
            </div>
            <div class="pen-container">
              <div @click="setCanvasType('draw')" class="pen-container-item">
                <img class="pen-icon" src="../assets/icon-pen.png" style="width:100%" />
                <img v-if="actionType == 'draw'" src="../assets/icon_selected.png"
                  style="width:1.8rem;position:absolute;bottom:0;right:0;z-index: 10;" />
              </div>
              <div class="color-selector">
                <div v-for="(item, index) in colorList" :key="index" class="color-item"
                  :style="{ background: item.color }" :class="{ 'color-selected': currentColor === item.color }"
                  @click="selectColor(item.color)" :title="item.name"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-right-container">
          <!-- 综合得分 -->
          <div class="score-section">
            <div class="score-label">综合得分：</div>
            <div class="score-value">{{ scoreGrade }}</div>
          </div>

          <!-- ========== templateVersion=2 布局 ========== -->
          <template v-if="isTemplateV2">
            <!-- 整体评价 -->
            <div class="v2-overall-comment" v-if="v2Data.整体评价">
              <div class="v2-section-title">整体评价</div>
              <div class="v2-overall-text">{{ v2Data.整体评价 }}</div>
            </div>

            <!-- 维度评分 -->
            <div class="v2-dimension-section" v-if="v2Data.维度评分 && v2Data.维度评分.length > 0">
              <div class="v2-section-title">维度评分</div>
              <div class="v2-dimension-grid">
                <div v-for="(item, index) in v2Data.维度评分" :key="index" class="v2-dimension-card">
                  <div class="v2-dim-ring">
                    <svg viewBox="0 0 36 36" class="v2-ring-svg">
                      <path class="v2-ring-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                      <path class="v2-ring-fill" :stroke="getDimColor(item.得分 / item.满分)"
                        :stroke-dasharray="(item.得分 / item.满分 * 100) + ', 100'"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                    </svg>
                    <div class="v2-ring-text">
                      <span class="v2-ring-num">{{ item.得分 }}</span>
                    </div>
                  </div>
                  <div class="v2-dim-label">{{ item.维度 }}</div>
                  <div class="v2-dim-fraction">{{ item.得分 }}/{{ item.满分 }}</div>
                </div>
              </div>
            </div>

            <!-- 改进建议 -->
            <div class="v2-suggestions" v-if="v2Data.改进建议 && v2Data.改进建议.length > 0">
              <div class="v2-section-title">改进建议</div>
              <div class="v2-suggestion-list">
                <div v-for="(text, index) in v2Data.改进建议" :key="index" class="v2-suggestion-item">
                  <span class="v2-suggestion-index">{{ index + 1 }}</span>
                  <span class="v2-suggestion-text">{{ text }}</span>
                </div>
              </div>
            </div>

            <!-- 名师鼓励 -->
            <div class="v2-encouragement" v-if="v2Data.名师鼓励">
              <div class="v2-encouragement-text">"{{ v2Data.名师鼓励 }}"</div>
            </div>

            <!-- 待优化字清单 + 视频 -->
            <div class="v2-optimize-words" v-if="v2FilteredWords.length > 0">
              <div class="v2-section-title">待优化字</div>
              <div class="rating-buttons">
                <div v-for="(item, index) in v2FilteredWords" :key="index" class="rating-btn"
                  :class="{ active: index === activeRatingIndex }" @click="selectV2Word(item, index)">
                  <div class="rating-btn-text">{{ item.char }}</div>
                </div>
              </div>
            </div>

            <!-- 视频区域 -->
            <div v-if="v2FilteredWords.length > 0" class="video-section">
              <div class="video-item" style="flex: 3;">
                <div class="video-thumbnail">
                  <course-video :exampleInfo="exampleInfo" :wordVideoInfo="wordVideoInfo"
                    @wordPopUp="wordPopUp"></course-video>
                </div>
                <div class="video-label">课程视频</div>
              </div>
              <div class="video-item">
                <div class="video-thumbnail">
                  <char-video :exampleInfo="exampleInfo" :wordVideoInfo="wordVideoInfo"
                    @wordPopUp="wordPopUp"></char-video>
                </div>
                <div class="video-label">范字视频</div>
              </div>
              <div class="video-item">
                <div class="video-thumbnail">
                  <char-book :exampleInfo="exampleInfo" :wordVideoInfo="wordVideoInfo" @wordPopUp="wordPopUp"></char-book>
                </div>
                <div class="video-label">范字板书</div>
              </div>
            </div>
          </template>

          <!-- ========== 旧版格式布局 ========== -->
          <template v-else>
            <!-- 评价按钮 -->
            <div class="rating-buttons">
              <div v-for="(item, index) in ratingOptions.filter((item, index) => index < 9)" :key="index" class="rating-btn"
                :class="{ active: index === activeRatingIndex }" @click="selectRating(item, index)">
                <div class="rating-btn-text">{{ item }}</div>
              </div>
            </div>

            <!-- AI评价与建议 -->
            <div class="ai-comment-section">
              <div class="ai-title">AI评价与建议</div>
              <div class="comment-content">
                <p v-for="(text, index) in aiCommentText" :key="index">
                  {{ text }}
                </p>
              </div>

              <!-- 维度评分 -->
              <div v-if="dimensionScoresList.length > 0" class="dimension-scores">
                <div class="dimension-title">各维度评分</div>
                <div class="dimension-grid">
                  <div v-for="(item, index) in dimensionScoresList" :key="index" class="dimension-item">
                    <span class="dimension-name">{{ item.category }}-{{ item.dimension }}</span>
                    <span class="dimension-score">{{ getDimensionGrade(item.category, item.score) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 视频区域 -->
            <div v-if="ratingOptions.length > 0" class="video-section">
              <div class="video-item" style="flex: 3;">
                <div class="video-thumbnail">
                  <course-video :exampleInfo="exampleInfo" :wordVideoInfo="wordVideoInfo"
                    @wordPopUp="wordPopUp"></course-video>
                </div>
                <div class="video-label">课程视频</div>
              </div>
              <div class="video-item">
                <div class="video-thumbnail">
                  <char-video :exampleInfo="exampleInfo" :wordVideoInfo="wordVideoInfo"
                    @wordPopUp="wordPopUp"></char-video>
                </div>
                <div class="video-label">范字视频</div>
              </div>
              <div class="video-item">
                <div class="video-thumbnail">
                  <char-book :exampleInfo="exampleInfo" :wordVideoInfo="wordVideoInfo" @wordPopUp="wordPopUp"></char-book>
                </div>
                <div class="video-label">范字板书</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <word-pop-new ref="word-pop"></word-pop-new>

  </div>
</template>

<script>
import CourseVideo from "./CourseVideo.vue";
import CharBook from "./CharBook.vue";
import CharVideo from "./CharVideo.vue";
import WordPopNew from "./WordPopNew.vue";
export default {
  name: "CommentPop",
  props: {},
  components: {
    CourseVideo,
    CharBook,
    CharVideo,
    WordPopNew,
  },
  data() {
    return {
      wordVideoInfo: null,
      exampleInfo: null,
      visible: false,
      videoInfo: null,
      boardInfo: null,
      commentData: null, // 点评数据
      // 画布相关
      canvasWidth: 0,
      canvasHeight: 0,
      canvas: null,
      ctx: null,
      actionType: "draw", // 'draw' 或 'eraser'
      currentColor: "#ff0000", // 当前选中的颜色，默认红色
      colorList: [
        { color: "#ff0000", name: "红色" },
        { color: "#00ff00", name: "绿色" },
        { color: "#0000ff", name: "蓝色" },
        { color: "#ffff00", name: "黄色" },
        { color: "#000000", name: "黑色" },
      ], // 可选颜色列表
      backgroundImage:
        "https://outin-9698ead669c111eab02000163e1a625e.oss-cn-shanghai.aliyuncs.com/image/default/AC3C433C80AC4CF38553C6A0A564FAAD-6-2.png", // 背景图片
      ratingOptions: ["杏", "乖", "斗", "卒"],
      activeRatingIndex: 0,
      isVoicePlaying: false,
      v2FilteredWords: [], // v2格式筛选后的待优化字列表 [{char, wordVideoInfo, exampleInfo}]
    };
  },
  computed: {

    backgroundStyle() {
      if (this.backgroundImage) {
        return `background: url('${this.backgroundImage}') no-repeat; background-size: contain; background-position: center;`;
      }
      return "";
    },

    // 解析后的点评内容
    parsedComment() {
      if (!this.commentData || !this.commentData.content) {
        return null;
      }
      return this.parseCommentContent(this.commentData.content);
    },

    // 是否为 templateVersion=2 的新格式
    isTemplateV2() {
      return this.parsedComment && this.parsedComment.templateVersion === 2;
    },

    // templateVersion=2 时的 output 数据
    v2Data() {
      if (!this.isTemplateV2 || !this.parsedComment.output) {
        return {};
      }
      return this.parsedComment.output;
    },

    // 综合得分
    totalScore() {
      if (this.commentData) {
        return this.commentData.score;
      }
      return 81.9; // 默认值
    },
    // 分数等级转换：>90=A+, 80-90=A, 70-80=A-, 60-70=B+, 50-60=B, 40-50=B-, 30-40=C+, 20-30=C, <20=C-
    scoreGrade() {
      const score = this.totalScore
      if (!score) return '--'

      if (score > 90) return 'A+'
      if (score > 80) return 'A'
      if (score > 70) return 'A-'
      if (score > 60) return 'B+'
      if (score > 50) return 'B'
      if (score > 40) return 'B-'
      if (score > 30) return 'C+'
      if (score > 20) return 'C'
      return 'C-'
    },
    // 维度得分列表
    dimensionScoresList() {
      if (!this.parsedComment || !this.parsedComment.dimensionScores) {
        return [];
      }

      const scores = this.parsedComment.dimensionScores;
      const result = [];

      Object.keys(scores).forEach(category => {
        const categoryScores = scores[category];
        Object.keys(categoryScores).forEach(dimension => {
          result.push({
            category,
            dimension,
            score: categoryScores[dimension]
          });
        });
      });

      return result;
    },

    // AI评价内容
    aiCommentText() {
      if (!this.parsedComment) {
        return [];
      }

      const feedback = this.parsedComment.feedback || {};
      const content = [];

      // 添加描述
      if (this.parsedComment.description) {
        content.push(this.parsedComment.description);
      }

      // 添加优点
      if (feedback.优点 && feedback.优点.length > 0) {
        content.push("优点：" + feedback.优点.join("；"));
      }

      // 添加建议
      if (feedback.建议 && feedback.建议.length > 0) {
        content.push("建议：" + feedback.建议.join("；"));
      }

      // 添加名言激励
      if (feedback.名言激励) {
        content.push("名言激励：" + feedback.名言激励);
      }

      return content.length > 0 ? content : [
        "暂无详细点评内容"
      ];
    }
  },
  mounted() {
    this.initCanvas();
  },
  beforeDestroy() {
    this.destroyCanvas();
  },
  methods: {
    /**
     * 根据得分比例返回环形颜色
     */
    getDimColor(ratio) {
      if (ratio >= 0.9) return '#52c41a'
      if (ratio >= 0.75) return '#1890ff'
      if (ratio >= 0.6) return '#faad14'
      return '#ff4d4f'
    },
    /**
         * 将维度分数转换为等级
         * @param {String} dimensionName - 维度名称
         * @param {Number} score - 分数
         * @returns {String} 等级（A+到C-）
         */
    getDimensionGrade(dimensionName, score) {
      if (!score && score !== 0) return '--'

      // 判断是否为满分10分的维度（完整、布局）
      const isTenPointScale = ['完整', '布局'].includes(dimensionName)
      const maxScore = isTenPointScale ? 10 : 20

      // 转换为百分比
      const percentage = (score / maxScore) * 100

      // 根据百分比返回等级
      if (percentage > 90) return 'A+'
      if (percentage > 80) return 'A'
      if (percentage > 70) return 'A-'
      if (percentage > 60) return 'B+'
      if (percentage > 50) return 'B'
      if (percentage > 40) return 'B-'
      if (percentage > 30) return 'C+'
      if (percentage > 20) return 'C'
      return 'C-'
    },
    wordPopUp({ data, tab }) {
      this.$refs["word-pop"].show(data, tab);
    },
    show(data) {
      let baseFontSize = getComputedStyle(window.document.documentElement)[
        "font-size"
      ].replace("px", "");
      this.canvasWidth = 26 * baseFontSize;
      this.canvasHeight = 37.6 * baseFontSize;

      // 如果传入的是点评数据
      if (data.id && data.content) {
        this.commentData = data;
        this.backgroundImage = data.imgUrl;
        this.videoInfo = null;
        this.boardInfo = null;
      } else {
        // 原有的视频数据逻辑
        this.videoInfo = data.videoInfo || null;
        this.boardInfo = data.boardInfo || null;
        this.commentData = null;
      }

      this.visible = true;
      this.$nextTick(() => {
        this.initCanvas();
        if (this.commentData) {
          // 如果是点评数据，不需要搜索字符
          this.wordVideoInfo = null;
          this.exampleInfo = null;

          // v2 格式使用待优化字清单，旧格式使用 wordList
          if (this.isTemplateV2 && this.v2Data.待优化字清单) {
            this.v2FilteredWords = [];
            this.preloadV2Words(this.v2Data.待优化字清单);
          } else {
            this.ratingOptions = data.wordList || [];
            this.activeRatingIndex = 0;
            if (this.ratingOptions.length > 0) {
              this.handleCharacterSelected(this.ratingOptions[0]);
            }
          }
        }
      });
    },

    handleCharacterSelected(char) {
      if (char === "") {
        this.wordVideoInfo = null;
        this.exampleInfo = null;
        return;
      }
      // 调用OCR识别接口
      this.$http
        .get(
          "https://api.xiaobixiezi.com/user/public/searchCoursePracticeByWord",
          { params: { word: char } }
        )
        .then((response) => {
          if (response.data.length > 0) {
            const words = response.data[0].physicsSegmentList;
            const examples = response.data[0].exampleList;
            const word = words.find((item) => item.title === char);
            const example = examples.find((item) => item.title === char);
            this.wordVideoInfo = word;
            this.exampleInfo = example;
          }
        });
    },

    /**
     * v2格式：预加载所有待优化字的数据，筛选出有数据的字
     */
    async preloadV2Words(charList) {
      const results = await Promise.all(
        charList.map(async (char) => {
          try {
            const response = await this.$http.get(
              "https://api.xiaobixiezi.com/user/public/searchCoursePracticeByWord",
              { params: { word: char } }
            );
            if (response.data && response.data.length > 0) {
              const words = response.data[0].physicsSegmentList || [];
              const examples = response.data[0].exampleList || [];
              const word = words.find((item) => item.title === char) || null;
              const example = examples.find((item) => item.title === char) || null;
              if (word || example) {
                return { char, wordVideoInfo: word, exampleInfo: example };
              }
            }
            return null;
          } catch (e) {
            return null;
          }
        })
      );
      this.v2FilteredWords = results.filter(Boolean);
      this.activeRatingIndex = 0;
      if (this.v2FilteredWords.length > 0) {
        this.selectV2Word(this.v2FilteredWords[0], 0);
      }
    },

    /**
     * v2格式：点击待优化字，从缓存数据中切换视频/板书
     */
    selectV2Word(item, index) {
      this.activeRatingIndex = index;
      this.wordVideoInfo = item.wordVideoInfo;
      this.exampleInfo = item.exampleInfo;
    },

    // 画布初始化
    initCanvas() {
      if (!this.$refs.canvas) return;

      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext("2d");

      // 添加事件监听
      this.canvas.addEventListener("mousedown", this.startEventHandler, false);
      this.canvas.addEventListener("touchstart", this.startEventHandler, false);
    },

    // 销毁画布
    destroyCanvas() {
      if (this.canvas) {
        this.canvas.removeEventListener(
          "mousedown",
          this.startEventHandler,
          false
        );
        this.canvas.removeEventListener(
          "touchstart",
          this.startEventHandler,
          false
        );
        this.canvas = null;
        this.ctx = null;
      }
    },

    // 设置画布类型（绘画/擦除）
    setCanvasType(type) {
      this.actionType = type;
    },

    // 选择颜色
    selectColor(color) {
      this.currentColor = color;
      if (this.actionType !== "draw") {
        this.actionType = "draw";
      }
    },

    // 清空画布
    clearCanvas() {
      if (this.ctx) {
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      }
    },

    // 开始绘画/擦除
    startEventHandler(ev) {
      if (!this.canvas || !this.ctx) return;

      let coverPos = this.canvas.getBoundingClientRect();
      var x, y;
      if (ev.touches && ev.touches.length > 0) {
        x = ev.touches[0].clientX - coverPos.left;
        y = ev.touches[0].clientY - coverPos.top;
      } else {
        x = ev.clientX - coverPos.left;
        y = ev.clientY - coverPos.top;
      }

      if (this.actionType === "draw") {
        this.ctx.beginPath();
      }
      this.ctx.moveTo(x, y);

      this.canvas.addEventListener("mousemove", this.moveEventHandler, false);
      this.canvas.addEventListener("touchmove", this.moveEventHandler, false);
      document.addEventListener("mouseup", this.endEventHandler, false);
      document.addEventListener("touchend", this.endEventHandler, false);
    },

    // 移动事件处理
    moveEventHandler(ev) {
      if (this.actionType === "draw") {
        this.draw(ev);
      } else {
        this.erase(ev);
      }
    },

    // 绘画
    draw(ev) {
      if (!this.canvas || !this.ctx) return;

      let coverPos = this.canvas.getBoundingClientRect();
      var targetX, targetY;
      if (ev.touches && ev.touches.length > 0) {
        targetX = ev.touches[0].clientX - coverPos.left;
        targetY = ev.touches[0].clientY - coverPos.top;
      } else {
        targetX = ev.clientX - coverPos.left;
        targetY = ev.clientY - coverPos.top;
      }

      this.ctx.lineWidth = 3;
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
      this.ctx.shadowBlur = 1;
      this.ctx.shadowColor = this.currentColor;
      this.ctx.strokeStyle = this.currentColor;
      this.ctx.lineTo(targetX, targetY);
      this.ctx.stroke();
    },

    // 擦除
    erase(ev) {
      if (!this.canvas || !this.ctx) return;

      let coverPos = this.canvas.getBoundingClientRect();
      var targetX, targetY;
      if (ev.touches && ev.touches.length > 0) {
        targetX = ev.touches[0].clientX - coverPos.left;
        targetY = ev.touches[0].clientY - coverPos.top;
      } else {
        targetX = ev.clientX - coverPos.left;
        targetY = ev.clientY - coverPos.top;
      }

      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.fillStyle = "#ffffff";
      this.ctx.arc(targetX, targetY, 20, 0, Math.PI * 2, true);
      this.ctx.clip();
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.ctx.restore();
    },

    // 结束绘画/擦除
    endEventHandler() {
      if (this.canvas) {
        this.canvas.removeEventListener(
          "mousemove",
          this.moveEventHandler,
          false
        );
        this.canvas.removeEventListener(
          "touchmove",
          this.moveEventHandler,
          false
        );
      }
      document.removeEventListener("mouseup", this.endEventHandler, false);
      document.removeEventListener("touchend", this.endEventHandler, false);
    },

    selectRating(item, index) {
      this.activeRatingIndex = index;
    },

    toggleVoice() {
      this.isVoicePlaying = !this.isVoicePlaying;
    },

    // 解析点评内容
    parseCommentContent(content) {
      try {
        if (typeof content === 'string') {
          return JSON.parse(content);
        }
        return content;
      } catch (error) {
        console.error('解析点评内容失败:', error);
        return {
          description: content || '暂无点评内容',
          dimensionScores: {},
          feedback: { optimizations: [], suggestions: [], quote: '' }
        };
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
.comment-pop {
  position: fixed;
  z-index: 999998;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.comment-pop-content {
  position: relative;
}

.close-btn {
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 0rem;
  right: -5rem;
  cursor: pointer;
  z-index: 100;
}

.close-btn img {
  width: 100%;
  height: 100%;
}

.main-container {
  width: 75rem;
  background: #fff;
  border-radius: 1rem;
  padding: 1.2rem;
  box-sizing: border-box;
  display: flex;
  gap: 1rem;
}

/* 左侧画布区域 */
.main-left-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.drawing-canvas {
  border-radius: 0.5rem;
  cursor: crosshair;
  background: white;
}

/* 右侧内容区域 */
.main-right-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 90vh;
  padding-left: 1rem;
}

/* 综合得分 */
.score-section {
  display: flex;
  align-items: center;
  color: #0f85db;
}

.score-label {
  font-size: 1.6rem;
}

.score-value {
  font-size: 1.6rem;
}

/* 评价按钮 */
.rating-buttons {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
}

.rating-btn {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: url("../assets/search-item-bg.png") no-repeat center center;
  background-size: 100% 100%;
  border-radius: 0.46rem 0.46rem 0.46rem 0.46rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  font-family: "FangZhengKaiTi", serif;
  font-size: 1.6rem;
  color: #b7b7b7;
}

.rating-btn.active {
  color: #3d465e;
  transform: scale(1.1);
  background: url("../assets/search-item-bg-active.png") no-repeat center center;
  background-size: 100% 100%;
}

.rating-btn:hover {
  border-color: #0f85db;
}

.rating-btn-text {
  margin: 0;
}

/* AI评价与建议 */
.ai-comment-section {
  flex: 1;
}

.ai-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.6rem;
}

.comment-content {
  margin-bottom: 0.6rem;
}

.comment-content p {
  margin: 0.5rem 0;
  color: #666;
  line-height: 1.5;
}

/* 维度评分样式 */
.dimension-scores {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed #e0e0e0;
}

.dimension-title {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.8rem;
}

.dimension-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.dimension-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0.8rem;
  background: #f8f9fa;
  border-radius: 0.3rem;
  font-size: 0.9rem;
}

.dimension-name {
  color: #666;
}

.dimension-score {
  color: #0f85db;
  font-weight: bold;
}

.expand-btn {
  text-align: center;
  color: #999;
  cursor: pointer;
  font-size: 0.9rem;
}

/* 视频区域 */
.video-section {
  margin-top: 0.6rem;
  padding-top: 0.6rem;
  border-top: 1px dashed #dedede;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

/* ========== templateVersion=2 样式 ========== */
.v2-overall-comment {
  margin: 0.8rem 0 0.4rem;
}

.v2-section-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  border-left: 3px solid #0f85db;
}

.v2-overall-text {
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
  padding: 0.5rem 0.8rem;
  background: #f0f7ff;
  border-radius: 0.4rem;
}

.v2-dimension-section {
  margin: 0.6rem 0;
}

.v2-dimension-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.5rem;
}

.v2-dimension-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.6rem 0.2rem 0.5rem;
  background: linear-gradient(135deg, #f6f9fc, #eef3f9);
  border-radius: 0.6rem;
  border: 1px solid #e8eef5;
  gap: 0.2rem;
  transition: transform 0.2s, box-shadow 0.2s;
}

.v2-dimension-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 133, 219, 0.12);
}

.v2-dim-ring {
  position: relative;
  width: 3.6rem;
  height: 3.6rem;
}

.v2-ring-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.v2-ring-bg {
  fill: none;
  stroke: #e8eef5;
  stroke-width: 3;
}

.v2-ring-fill {
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dasharray 0.8s ease;
}

.v2-ring-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.v2-ring-num {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
}

.v2-dim-label {
  font-size: 0.85rem;
  color: #333;
  font-weight: 500;
}

.v2-dim-fraction {
  font-size: 0.7rem;
  color: #999;
}

.v2-suggestions {
  margin: 0.6rem 0;
}

.v2-suggestion-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.v2-suggestion-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;
  background: #fafafa;
  border-radius: 0.3rem;
  font-size: 0.9rem;
  color: #555;
  line-height: 1.5;
}

.v2-suggestion-index {
  flex-shrink: 0;
  width: 1.3rem;
  height: 1.3rem;
  background: #0f85db;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  margin-top: 0.1rem;
}

.v2-suggestion-text {
  flex: 1;
}

.v2-encouragement {
  margin: 0.5rem 0;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #fff8e1, #fff3cd);
  border-radius: 0.4rem;
  border-left: 3px solid #f5a623;
}

.v2-encouragement-text {
  font-size: 0.95rem;
  color: #8b6914;
  line-height: 1.5;
  font-style: italic;
}

.v2-optimize-words {
  margin: 0.5rem 0;
}

.video-item {
  flex-shrink: 0;
  text-align: center;
  flex: 2;
}

.video-thumbnail {
  width: 100%;
  height: 10rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.characters {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  display: flex;
  gap: 0.5rem;
}

.rabbit-icon,
.minion-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: white;
  padding: 0.2rem;
}

.video-label {
  font-size: 0.9rem;
  color: #666;
}

/* 工具栏 */
.toolbar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.pen-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: #16a0e933;
  padding: 0.48rem 0.96rem;
  border-radius: 3.63rem 3.63rem 3.63rem 3.63rem;
}

.pen-container-item {
  position: relative;
}

.pen-icon {
  width: 4.04rem;
  height: 4.04rem;
}

.color-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

.color-item {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #ffffff;
  transition: all 0.2s;
  position: relative;
}

.color-item.color-selected {
  width: 1.6rem;
  height: 1.6rem;
}

.color-item::after {
  content: "";
  display: block;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
}

.eraser-container {
  position: relative;
}

.eraser-container-item {
  position: relative;
}

.eraser-icon {
  width: 4.6rem;
  height: 4.6rem;
}

.voice-btn {
  margin-left: auto;
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: #e8f4ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.voice-btn.playing {
  background: #0f85db;
}

.voice-btn:hover {
  transform: scale(1.05);
}

.voice-icon {
  position: relative;
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
}

.voice-icon::before {
  display: none;
}

.voice-btn.playing .voice-icon::before {
  display: none;
}

.voice-bar {
  width: 0.15rem;
  height: 0.3rem;
  background: #0f85db;
  border-radius: 0.075rem;
  transition: all 0.1s ease;
}

.bar1 {
  height: 0.4rem;
}

.bar2 {
  height: 0.6rem;
}

.bar3 {
  height: 0.8rem;
}

.bar4 {
  height: 0.5rem;
}

.bar5 {
  height: 0.3rem;
}

.voice-btn.playing .voice-bar {
  background: white;
  animation-duration: 1.2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

.voice-btn.playing .bar1 {
  animation-delay: 0s;
  animation-name: voiceWave1;
}

.voice-btn.playing .bar2 {
  animation-delay: 0.1s;
  animation-name: voiceWave2;
}

.voice-btn.playing .bar3 {
  animation-delay: 0.2s;
  animation-name: voiceWave3;
}

.voice-btn.playing .bar4 {
  animation-delay: 0.3s;
  animation-name: voiceWave4;
}

.voice-btn.playing .bar5 {
  animation-delay: 0.4s;
  animation-name: voiceWave5;
}

@keyframes voiceWave1 {

  0%,
  100% {
    height: 0.4rem;
  }

  50% {
    height: 0.7rem;
  }
}

@keyframes voiceWave2 {

  0%,
  100% {
    height: 0.6rem;
  }

  50% {
    height: 1rem;
  }
}

@keyframes voiceWave3 {

  0%,
  100% {
    height: 0.8rem;
  }

  50% {
    height: 1.2rem;
  }
}

@keyframes voiceWave4 {

  0%,
  100% {
    height: 0.5rem;
  }

  50% {
    height: 0.9rem;
  }
}

@keyframes voiceWave5 {

  0%,
  100% {
    height: 0.3rem;
  }

  50% {
    height: 0.6rem;
  }
}
</style>
